/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

const CFT_PREFIX = 'com.atlassian.jira.plugin.system.customfieldtypes:';
const EXCLUDE_FIELDS = ['attachment', 'comment', 'issuetype', 'project', 'timetracking', 'issuelinks'];

export const includeField = (field: object, customExcludeFields = []) =>
  EXCLUDE_FIELDS.indexOf(field.key) === -1 &&
  customExcludeFields.indexOf(field.key) === -1 &&
  (!field.schema.custom || field.schema.custom.indexOf(CFT_PREFIX) === 0);
